/**
 * @file navbar config
 * @author cauguoqing
 */

import {
  HomeIcon,
  CampaignIcon,
  ReportNavIcon,
  NavbarHeadFillIcon,
  ActiveHomeIcon,
  ActiveNavbarHeadFillIcon,
  ActiveCampaignIcon,
  ActiveReportNavIcon,
  HeadsDNAIcon,
} from "../icons";

// 使用函数返回菜单列表，这样可以动态获取翻译
export const getMenuList = (t: any) => [
  {
    Icon: HomeIcon,
    ActiveIcon: ActiveHomeIcon,
    label: t('navbar.menu.home'),
    route: "/home",
  },
  {
    Icon: CampaignIcon,
    ActiveIcon: ActiveCampaignIcon,
    label: t('navbar.menu.campaign'),
    route: "/campaign",
  },
  {
    Icon: ReportNavIcon,
    ActiveIcon: ActiveReportNavIcon,
    label: t('navbar.menu.report'),
    route: "/report",
  },
  // {
  //   Icon: HeadsDNAIcon,
  //   ActiveIcon: HeadsDNAIcon,
  //   label: t('navbar.menu.dna'),
  //   route: "/head",
  // },
];

// 保持向后兼容
export const menuList = getMenuList(() => '');
